// extracted by css-extract-rspack-plugin
export default {"tokenList":"TokenList-module__tokenList__soETq"};